import BonuspackCouponNudgeImg from './bonuspack_coupon.webp';
import CouponBonuspackNudgeImg from './coupon_bonuspack_nudge.webp';
import CouponFreeNudgeImg from './coupon_free_nudge.webp';
import CouponMembershipNudgeImg from './coupon_membership_nudge.webp';
import MembershipCouponNudgeImg from './membership_coupon.webp';
import MypageBonuspackNudgeImg from './mypage_bonuspack.webp';
import MypageTrialNudgeImg from './mypage_free_trial.webp';
import MypageMembershipNudgeImg from './mypage_membership.webp';

export {
  BonuspackCouponNudgeImg,
  CouponBonuspackNudgeImg,
  CouponFreeNudgeImg,
  CouponMembershipNudgeImg,
  MembershipCouponNudgeImg,
  MypageBonuspackNudgeImg,
  MypageMembershipNudgeImg,
  MypageTrialNudgeImg,
};
